import { render, staticRenderFns } from "./MeetTheTeam.vue?vue&type=template&id=452221dc&"
import script from "./MeetTheTeam.vue?vue&type=script&lang=ts&"
export * from "./MeetTheTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports